var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 33.2367C11.2335 33.2367 4.9375 26.9407 4.9375 19.1742C4.9375 11.4077 11.2335 5.11169 19 5.11169C26.7665 5.11169 33.0625 11.4077 33.0625 19.1742C33.054 26.9372 26.763 33.2282 19 33.2367ZM19 7.92419C12.7868 7.92419 7.75 12.961 7.75 19.1742C7.75 25.3874 12.7868 30.4242 19 30.4242C25.2132 30.4242 30.25 25.3874 30.25 19.1742C30.243 12.9639 25.2103 7.93117 19 7.92419ZM26.0312 20.5804H17.5938V12.1429H20.4062V17.7679H26.0312V20.5804Z",
    fill: "#A71D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.faa09b8345f94e28f8b37e21026b427e.svg";
export { ForwardRef as ReactComponent };